import React, { useLayoutEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useLanguage } from './LanguageContext';
import { LANGUAGES } from '../data/i18n';
import NotFound from '../pages/NotFound';

// Wraps /en/* and /pl/* routes: the URL prefix sets the site language.
const LanguageRoute = () => {
  const { lang } = useParams();
  const { lang: current, setLang } = useLanguage();
  const valid = LANGUAGES.includes(lang);

  useLayoutEffect(() => {
    if (valid && lang !== current) setLang(lang);
  }, [lang]);

  return valid ? <Outlet /> : <NotFound />;
};

export default LanguageRoute;
